import { Grid, Paper, Typography } from '@material-ui/core';
import _ from 'lodash';
import React, { lazy, Suspense } from 'react';
import { withRouter } from 'react-router-dom';
import ApiForm from './ApiForm';
import AutocompleteInput from './AutocompleteInput';
import ButtonWithStore from './ButtonWithStore';
import { Loader } from './helpers';
import IconInput from './IconInput';
//import DateInput from './DateInput';
//import EmailTextareaInput from './EmailTextareaInput';
//import FileInput from './FileInput';
//import ImageInput from './ImageInput';
import PlainTextareaInput from './PlainTextareaInput';
import SelectInput from './SelectInput';
//import TextareaInput from './TextareaInput';
import TextInput from './TextInput';
import StopwatchInput from './StopwatchInput';
import SwitchInput from './SwitchInput';

const TextareaInput = lazy(() => import('./TextareaInput'));
const EmailTextareaInput = lazy(() => import('./EmailTextareaInput'));
const FileInput = lazy(() => import('./FileInput'));
const ImageInput = lazy(() => import('./ImageInput'));
const DateInput = lazy(() => import('./DateInput'));


//Smart Form which Generate Form based on passed props
//Can be trigger automatically or manually
class SmartForm extends ApiForm {
    static defaultProps = {
        redirect: '/dashboard',
        actionMessage: 'Saved Successfully',
        actionType: 'update',
        buttonTitle: 'Update',
        fetchUrl: '',
        actionUrl: '',
        form: {},
        errors: {},
        fields: [],
        rebuildOnUpdate: false,
        noPaper: false,
        noButton: false,
        onFormSaved: function (data) { },
        onFormFailed: function (data) { },
        onFormFetched: function (data) { },
        initData: false,
        triggerSave: false,
        fetchWithLock: false,
        lock: false,
        resetOnSave: false,
        disabled: false,
    }
    state = {
        fetchUrl: '',
        actionUrl: '',
        errors: {
            enabled: false,
        },
        form: {},
        render: {},
        loading: false,
        formLoaded: false,
    }
    /*
    -----------------------------------------------------------------------
    API Functions
    -----------------------------------------------------------------------
    */
    beginPerformAction = async () => {
        const completed = await this.performAction();
        if (completed && this.props.resetOnSave) {
            this.initForm(true);
        }
    }
    /*
    -----------------------------------------------------------------------
    RENDER Functions
    -----------------------------------------------------------------------
    */
    //Handle Value Change of form from parent
    componentDidUpdate(prevProps, prevState) {
        let form = prevState.form;
        let changed = false;
        this.props.fields.forEach((item, key) => {
            if ((prevProps.fields.length && typeof (prevProps.fields[key]) === 'undefined') ||
                (typeof (item.value) !== 'undefined' && form[item.name] !== item.value && item.value !== prevProps.fields[key].value)) {
                form[item.name] = item.value;
                changed = true;
            }
        });
        if (changed)
            this.setState({ form: form });
        if (this.props.rebuildOnUpdate && JSON.stringify(prevProps.fields) !== JSON.stringify(this.props.fields)) {
            this.initForm(false, prevProps);
        }
        //Save is triggered from outside
        if (this.props.triggerSave && !prevProps.triggerSave)
            this.beginPerformAction();

    }
    //Trigger Init Form and Setup Fields
    componentDidMount() {
        this.initForm(true);
    }
    //Handle Form Data Fetched
    formDataDidFetch = async (data) => {
        await _.each(this.props.fields, (item, key) => {
            if (typeof (item.onChange) === 'function') {
                item.onChange(this.state.form[item.name]);
            }
        });
        await this.setState({ formLoaded: true });
        this.props.onFormFetched(data);
    }
    //Init Form and Setup Fields
    initForm(newForm, prevProps) {
        let newState = this.state;
        newState.render = {};
        this.props.fields.forEach((field) => {
            //Add field to form
            if (newForm && field.name) {
                newState.form[field.name] = field.value || (['date', 'datetime', 'switch'].indexOf(field.type) !== -1 ? null : '');
                //Add url if field is a file to form
                if (['image', 'file'].indexOf(field.type) !== -1)
                    newState.form[field.name + '_url'] = field[field.name + '_url'] || '';
            }
            //Prepare render array
            newState.render[field.name] = {
                type: field.type,
                width: field.width,
                title: field.title,
                multi: field.multi,
                disabled: this.props.disabled || field.disabled || false,
                data: typeof (field.data) !== 'undefined' ? field.data : false,
                onChangeEventForParent: field.onChange,
                nameKey: field.nameKey || 'name',
                description: field.description || null,
                template: field.template || null,
                required: field.required || false,
                autoComplete: field.autoComplete === undefined ? true : field.autoComplete,
                hidden: field.hidden || false,
                variant: field.variant || 'standard',
                max: field.max || null,
                onChangeRefill: field.onChangeRefill || '',
                localize: field.localize,
                params: field.params || {},
                extraMarkup: field.extraMarkup || null,
            };

            if (field.required)
                newState.errors[field.name] = false;
            else delete newState.errors[field.name];
            newState.errors.enabled = false;
        })

        if (this.props.initData) {
            if (!prevProps || this.props.initData !== prevProps.initData)
                newState.form = _.pick(this.props.initData, _.keys(this.state.form));
            this.setState(newState);
        }
        else {
            this.setState(newState);
            if (newForm)
                super.triggerFetchData();
        }
    }
    //Render Fields
    renderFields() {
        let fields = this.state.render;
        let renderdFields = [];
        const formLoaded = this.state.formLoaded;
        const { errors, form } = this.state;
        _.each(fields, (item, key) => {
            if (typeof (item.hidden) === 'function') {
                item.hidden = item.hidden.bind(this);
            }
            switch (item.type) {
                case 'text':
                case 'password':
                case 'email':
                case 'number': {
                    renderdFields.push(
                        <TextInput key={key} max={item.max} width={item.width} error={errors[key]} value={form[key]} enabled={errors.enabled}
                            onChange={this.onChange} type={item.type} name={key} title={item.title} disabled={item.disabled}
                            formLoaded={formLoaded} description={item.description} required={item.required}
                            autoComplete={item.autoComplete} hidden={item.hidden} variant={item.variant}
                            localize={item.localize}
                        />
                    )
                    break;
                }
                case 'date': {
                    renderdFields.push(
                        <DateInput key={key} width={item.width} error={errors[key]} value={form[key]} enabled={errors.enabled}
                            onChange={this.onChange} type={item.type} name={key} title={item.title} disabled={item.disabled}
                            formLoaded={formLoaded} description={item.description} required={item.required}
                            autoComplete={item.autoComplete} hidden={item.hidden} variant={item.variant} />
                    )
                    break;
                }

                case 'plaintextarea': {
                    renderdFields.push(
                        <PlainTextareaInput key={key} width={item.width} error={errors[key]} value={form[key]} enabled={errors.enabled}
                            onChange={this.onChange} type={item.type} name={key} title={item.title} formLoaded={formLoaded}
                            description={item.description} required={item.required} localize={item.localize}
                            disabled={item.disabled} max={item.max} hidden={item.hidden} variant={item.variant} />
                    )
                    break;
                }
                case 'select': {
                    renderdFields.push(
                        <SelectInput key={key} width={item.width} error={errors[key]} value={form[key] + ""} enabled={errors.enabled}
                            onChange={this.onChange} type={item.type} name={key} title={item.title} data={item.data} formLoaded={formLoaded}
                            description={item.description} required={item.required}
                            disabled={item.disabled} hidden={item.hidden} variant={item.variant} />
                    )
                    break;
                }
                case 'autocomplete': {
                    renderdFields.push(
                        <AutocompleteInput key={key} nameKey={item.nameKey} multi={item.multi} width={item.width} error={errors[key]} value={form[key]} enabled={errors.enabled}
                            onChange={this.onChange} type={item.type} name={key} title={item.title} data={item.data} formLoaded={formLoaded}
                            description={item.description} required={item.required} params={item.params}
                            disabled={item.disabled} hidden={item.hidden} variant={item.variant} />
                    )
                    break;
                }
                case 'image': {
                    renderdFields.push(
                        <ImageInput key={key} width={item.width} error={errors[key]} value={form[key]} url={form[key + '_url']} enabled={errors.enabled}
                            onChange={this.onChange} type={item.type} name={key} title={item.title} data={item.data} formLoaded={formLoaded}
                            description={item.description} template={item.template} disabled={item.disabled}
                            required={item.required} hidden={item.hidden} variant={item.variant} />
                    )
                    break;
                }
                case 'file': {
                    renderdFields.push(
                        <FileInput key={key} width={item.width} error={errors[key]} value={form[key]} url={form[key + '_url']} enabled={errors.enabled}
                            onChange={this.onChange} type={item.type} name={key} title={item.title} data={item.data} formLoaded={formLoaded}
                            description={item.description} template={item.template} disabled={item.disabled} max={item.max}
                            required={item.required} hidden={item.hidden} variant={item.variant} />
                    )
                    break;
                }
                case 'textarea': {
                    renderdFields.push(
                        <TextareaInput key={key} width={item.width} error={errors[key]}
                            value={form[key] ? form[key] : ''} enabled={errors.enabled}
                            onChange={this.onChange} type={item.type} name={key}
                            title={item.title} data={item.data} formLoaded={formLoaded}
                            description={item.description} required={item.required}
                            max={item.max} disabled={item.disabled} hidden={item.hidden}
                            variant={item.variant} localize={item.localize}
                            extraMarkup={item.extraMarkup}
                        />
                    )
                    break;
                }
                case 'hidden': {
                    renderdFields.push(<span key={key}></span>);
                    break;
                }
                case 'emailtextarea': {
                    renderdFields.push(
                        <EmailTextareaInput ref={emailEditor => this.emailEditor = emailEditor} key={key} width={item.width} error={errors[key]} value={form[key] ? form[key] : ''} enabled={errors.enabled}
                            onChange={this.onChange} type={item.type} name={key} title={item.title} data={item.data} formLoaded={formLoaded}
                            description={item.description} required={item.required}
                            disabled={item.disabled} hidden={item.hidden} variant={item.variant} />
                    )
                    break;
                }
                case 'icon': {
                    renderdFields.push(
                        <IconInput key={key} width={item.width} error={errors[key]} value={form[key] ? form[key] : ''} enabled={errors.enabled}
                            onChange={this.onChange} type={item.type} name={key} title={item.title} data={item.data} formLoaded={formLoaded}
                            description={item.description} required={item.required}
                            disabled={item.disabled} hidden={item.hidden} variant={item.variant} />
                    )
                    break;
                }
                case 'stopwatch': {
                    renderdFields.push(
                        <StopwatchInput key={key} width={item.width} error={errors[key]} value={form[key] ? form[key] : ''} enabled={errors.enabled}
                            onChange={this.onChange} type={item.type} name={key} title={item.title} data={item.data} formLoaded={formLoaded}
                            description={item.description} hidden={item.hidden} required={item.required} disabled={item.disabled} />
                    )
                    break;
                }
                case 'switch': {
                    renderdFields.push(
                        <SwitchInput key={key} width={item.width} error={errors[key]} value={form[key] ? form[key] : ''} enabled={errors.enabled}
                            onChange={this.onChange} type={item.type} name={key} title={item.title} data={item.data} formLoaded={formLoaded}
                            description={item.description} hidden={item.hidden} required={item.required} disabled={item.disabled} />
                    )
                    break;
                }
                case 'title': {
                    if (item.hidden)
                        break;
                    renderdFields.push(<Grid item xs={12} ><Typography variant={"h5"} className='title-box-shadow' key={key}>{item.title}</Typography></Grid>);
                    break;
                }
                default: {
                    renderdFields.push(
                        <TextInput key={key} width={item.width} error={errors[key]} value={form[key]} enabled={errors.enabled}
                            onChange={this.onChange} type={item.type} name={key} title={item.title} disabled={item.disabled}
                            formLoaded={formLoaded} description={item.description} required={item.required}
                            autoComplete={item.autoComplete} hidden={item.hidden} localize={item.localize} variant={item.variant} />
                    )
                }
            }
        });
        return renderdFields;
    }
    render() {
        //Doesen't Matter just a templete
        const { form } = this.state;
        if (this.props.noPaper)
            return (

                <form >
                    <Suspense fallback={<Loader />}>
                        <Grid container spacing={2}>
                            {this.renderFields()}
                        </Grid>
                        {!this.props.noButton && <ButtonWithStore title={this.props.buttonTitle} disabled={this.state.loading} action={this.beginPerformAction} />}
                    </Suspense>
                </form>
            )
        else
            return (
                <Paper elevation={2} className="allpadding-lg" >
                    <Suspense fallback={<Loader />}>
                        <form >
                            <Grid container spacing={2}>
                                {this.renderFields()}
                            </Grid>
                            {!this.props.noButton && <ButtonWithStore title={this.props.buttonTitle} disabled={this.state.loading} action={this.beginPerformAction} />}
                        </form>
                    </Suspense>
                </Paper>
            )
    }
}


export default withRouter(SmartForm);